"use client";

import { OffersCarousalSkeleton } from "@/components/EmblaSlider";
import EmblaShopSlider from "@/templates/slider/emblaShopSlider";
import HeroSlider from "@/templates/slider/heroSlider";
import { useEffect, useState } from "@/utils/hooks/reactUseCustomHooks";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import { searchMultiIndex } from "../getAlgoliaMulti";
import { GSP_NO_RETURNED_VALUE } from "next/dist/lib/constants";
import EmblaCategorySlider from "@/templates/slider/emblaCategorySlider";
import FreshBread from "../_components/Content/FreshBread";
import SectionTitle from "../_components/Content/SectionTitle";
import { SiteContainer } from "@/components/Container";
import EmblaFlyerOfferSlider from "@/templates/slider/emblaFlyerOffersSlider";
import { Box, Row, Columns } from "@dxp-feed/ui";
import EmblaMassOfferSlider from "@/templates/slider/emblaMassOffersSlider";
import EmblaTrendingProductSlider from "@/templates/slider/emblaTrendingProductSlider";
import { useSelector } from "react-redux";
import { RootState } from "@/utils/redux/store";
import EmblaSpecificDealsSlider from "@/templates/slider/emblaSpecificDealsSlider";
import ImageWrapper from "@/components/ImageWrapper";
import Link from "next/link";
import { dataLayerVoilaButton } from "@/helpers/dataLayer";
import { promotionMapping } from "@/utils/promotions";
import useWindowSize from "@/utils/hooks/useWindowSize";
import { useTrendingItems } from "@/utils/hooks/useTrendingItems";

export const HeroSliderWrapper = ({ carouselWrapperData }: any) => {
  const [carouselData, setCarouselData] = useState(null);
  const { storeRegion } = useStoreDetails();
  useEffect(() => {
    if (storeRegion?.length) {
      setCarouselData(
        carouselWrapperData?.carouselList?.filter((item: any) =>
          item.targetArea.some((area: any) =>
            area.toLowerCase().includes(storeRegion?.toLowerCase())
          )
        )
      );
    }
  }, [storeRegion]);

  return (
    <HeroSlider
      carouselData={carouselData}
      carouselWrapperData={carouselWrapperData}
    />
  );
};

export const ShopSliderWrapper = ({ aemData }: any) => {
  const { storeRegion, storeID } = useStoreDetails();
  const [homeProductData, setHomeProductData] = useState<any>({});
  const { width } = useWindowSize();
  useEffect(() => {
    if (storeRegion?.length && storeID?.length) {
      searchMultiIndex({
        homeContentData: aemData?.containerData,
        storeID,
        storeRegion,
      })
        .then((data) => {
          setHomeProductData(data);
        })
        .catch(() => { });
    }
  }, [storeRegion]);
  const voilaCardDetail =
    aemData?.containerData?.containerData?.columncontrol_898695505?.[
      ":items"
    ]?.["column-2"]?.[":items"]?.image;
  return homeProductData?.results?.[0]?.hits === 0 ? null : (
    <>
      {/* Replaced Columns for ShopSliderWrapper with a div */}
      <div className="w-full sm:w-full lg:w-9/12 xl:w-10/12 px-2">
        <EmblaShopSlider
          base={1.2}
          xsm={2.2}
          sm={2.2}
          md={3.4}
          lg={3}
          xl={3}
          xml={4}
          xxl={5}
          displayedFrom={"homeContentPage"}
          homeProductData={homeProductData?.results?.[0]?.hits}
          sectionTitle={
            aemData?.containerData?.containerData?.sectionheadinglink?.heading
          }
        />
      </div>
      {/* Replaced Columns for Voila card with a div */}
      <div className="w-full sm:w-full lg:w-3/12 xl:w-2/12 px-2 voila">
        {/* <div className="mr-6 lg:mr-0 h-full">
          <Link
            href={voilaCardDetail?.link ?? process.env.NEXT_PUBLIC_VOILA_URL}
            target="_blank"
            className="w-full h-full m-0 p-0 rounded-[12px] overflow-hidden  mt-4 lg:mt-0 px-2 lg:px-0"
            onClick={() => {
              dataLayerVoilaButton({
                event: "voila_button",
                click_text: "Voila",
                click_url:
                  voilaCardDetail?.link ?? process.env.NEXT_PUBLIC_VOILA_URL,
                page_title: document.title,
              });
            }}
          >
            <ImageWrapper
              src={
                voilaCardDetail?.src
                  ? `${process.env.NEXT_PUBLIC_AEM_PATH_URL}/${voilaCardDetail?.src}}`
                  : "/home/delivery_voila.avif"
              }
              width={300}
              height={400}
              className={`${homeProductData?.results?.[0]?.hits?.length > 5 ? "h-[calc(100%-68px)]" : "h-full"} voilaImage w-full md:w-[80%] lg:w-[90%] 2lg:w-full lg:max-w-full lg:max-h-[355px] 2lg:max-h-[354px] 3xl:max-h-[375px] 5xl:max-h-[355px] lg:mt-[0px] lg:object-fit rounded-[38px] lg:rounded-[12px] lg:min-h-[315px] m-auto`}
              alt="voila card"
            />
          </Link>
        </div> */}
        <div className="mr-6 lg:mr-0 h-full">
          <Link
            href={
              voilaCardDetail?.link
                ? voilaCardDetail?.link
                : process.env.NEXT_PUBLIC_VOILA_URL
            }
            target="_blank"
            className="w-full h-full m-0 p-0 rounded-[12px] overflow-hidden  mt-4 lg:mt-0 px-2 lg:px-0"
            onClick={() => {
              dataLayerVoilaButton({
                event: "voila_button",
                click_text: "Voila",
                click_url: voilaCardDetail?.link
                  ? voilaCardDetail?.link
                  : process.env.NEXT_PUBLIC_VOILA_URL,
                page_title: document.title,
              });
            }}
          >
            {width <= 1023 ? (
              <ImageWrapper
                src={
                  voilaCardDetail?.src
                    ? `${process.env.NEXT_PUBLIC_AEM_PATH_URL}/${voilaCardDetail?.src}}`
                    : "/home/delivery_voila.avif"
                }
                width={300}
                height={400}
                className={`${homeProductData?.results?.[0]?.hits?.length > 5 ? "h-[calc(100%-75px)]" : "h-full"} voilaImage w-full md:w-[80%] lg:w-[90%] 2lg:w-full lg:max-w-full lg:max-h-[355px] 2lg:max-h-[354px] 3xl:max-h-[375px] 5xl:max-h-[355px] lg:mt-[0px] lg:object-cover rounded-[38px] lg:rounded-[12px] lg:min-h-[315px] m-auto`}
                alt="voila card"
              />
            ) : (
              <div
                style={{
                  backgroundImage: `url('${voilaCardDetail?.src
                      ? `${process.env.NEXT_PUBLIC_AEM_PATH_URL}/${voilaCardDetail?.src}`
                      : "/home/delivery_voila.avif"
                    }')`,
                  backgroundSize: "100% 100%",
                  backgroundPosition: "top center",
                  backgroundRepeat: "no-repeat",
                }}
                className={`${homeProductData?.results?.[0]?.hits?.length > 5
                    ? "h-[calc(100%-74px)]"
                    : "h-[calc(100%-6px)]"
                  } voilaImage w-full md:w-[80%] lg:w-[90%] 2lg:w-full lg:max-w-full lg:mt-[0px] lg:object-cover rounded-[38px] lg:rounded-[12px] lg:min-h-[319px] m-auto `}
              />
            )}
          </Link>
        </div>
      </div>
    </>
  );
};

export const CategorySliderWrapper = ({ aemData }: any) => {
  const { storeRegion } = useStoreDetails();
  return (
    <EmblaCategorySlider
      productcategories={
        aemData?.containerData?.containerData?.productcategories?.locationMap?.[
          storeRegion
        ]?.categories
      }
      clickedFrom={"homeContentPage"}
    />
  );
};

export const FreshBreadWrapper = ({ aemData }: any) => {
  const { storeRegion, storeID } = useStoreDetails();
  const [homeProductData, setHomeProductData] = useState<any>({});

  useEffect(() => {
    if (storeRegion?.length && storeID?.length) {
      searchMultiIndex({
        homeContentData: aemData?.containerData,
        storeID,
        storeRegion,
      })
        .then((data) => {
          setHomeProductData(data);
        })
        .catch(() => { });
    }
  }, [storeRegion]);
  return (
    <FreshBread
      columnControl={
        aemData?.containerData?.containerData?.columncontrol?.[":items"]
      }
      displayedFrom={"homeContentPage"}
      homeProductData={homeProductData?.results?.[1]?.hits}
      sectionTitle={
        aemData?.containerData?.containerData?.sectionheadinglink_308587068
          ?.heading
      }
    />
  );
};

export const FlyerOffersWrapper = ({ aemData }: any) => {
  const { storeRegion, storeID } = useStoreDetails();
  const [homeProductData, setHomeProductData] = useState<any>({});
  useEffect(() => {
    if (storeRegion?.length && storeID?.length) {
      searchMultiIndex({
        homeContentData: aemData?.containerData,
        storeID,
        storeRegion,
      })
        .then((data) => {
          setHomeProductData(data);
        })
        .catch(() => { });
    }
  }, [storeRegion]);

  return homeProductData?.results?.[3]?.hits?.length === 0 ? null : (
    <>
      <SectionTitle
        as="h2"
        title={
          aemData?.containerData?.containerData?.sectionheadinglink_1011728735
            ?.heading
        }
        ctaText={
          aemData?.containerData?.containerData?.sectionheadinglink_1011728735
            ?.ctatext
        }
        ctaLink={
          aemData?.containerData?.containerData?.sectionheadinglink_1011728735
            ?.ctalink
        }
        ctatarget={
          aemData?.containerData?.containerData?.sectionheadinglink_1011728735
            ?.ctatarget
        }
        ctalabel={
          aemData?.containerData?.containerData?.sectionheadinglink_1011728735
            ?.ctaAriaLabel
        }
      />
      <SiteContainer className=" !pl-6 !pr-0 2md:!pl-12 lg:!px-12 overflow-hidden ">
        <Box as="div" className="mb-[0]">
          <Row>
            <Columns className="col-12 col-sm-12 col-lg-12 col-xl-12">
              <EmblaFlyerOfferSlider
                base={1.2}
                xsm={2.2}
                sm={2.2}
                md={3.4}
                lg={4}
                xl={4}
                xml={5}
                xxl={6}
              />
            </Columns>
          </Row>
        </Box>
      </SiteContainer>
    </>
  );
};

export const MassoffersWrapper = ({ aemData }: any) => {
  const { storeRegion, storeID } = useStoreDetails();
  const [showMassOffers, setShowMassOffers] = useState(false);
  const fetchPromotionsData = async (item: any) => {
    try {
      const data = await promotionMapping([item]);
      return data ?? [];
    } catch (error) {
      console.error(error, "Error fetching promotions data");
    }
  };

  const fetchPromotionsForProducts = async (productsData: any[]) => {
    const productsWithPromos = await Promise.all(
      productsData.map(async (product: any) => {
        try {
          const data = await fetchPromotionsData(product);
          return { product, hasPromotions: data?.length > 0 };
        } catch (error) {
          console.error(error);
          return { product, hasPromotions: false };
        }
      })
    );

    return productsWithPromos.filter((p) => p.hasPromotions);
  };
  useEffect(() => {
    if (storeRegion?.length && storeID?.length) {
      searchMultiIndex({
        homeContentData: aemData?.containerData,
        storeID,
        storeRegion,
      })
        .then(async (data) => {
          if (!(data?.results?.[4]?.hits?.length === 0)) {
            const arr = await fetchPromotionsForProducts(
              data?.results?.[4]?.hits
            );
            if (arr.length === 0) setShowMassOffers(false);
            else setShowMassOffers(true);
          }
        })
        .catch(() => { });
    }
  }, [storeRegion]);
  return showMassOffers ? (
    <>
      <SectionTitle
        as="h2"
        title={
          aemData?.containerData?.containerData?.sectionheadinglink_1651730460
            ?.heading
        }
        ctaText={
          aemData?.containerData?.containerData?.sectionheadinglink_1651730460
            ?.ctatext
        }
        ctaLink={
          aemData?.containerData?.containerData?.sectionheadinglink_1651730460
            ?.ctalink
        }
        ctatarget={
          aemData?.containerData?.containerData?.sectionheadinglink_1651730460
            ?.ctatarget
        }
        ctalabel={
          aemData?.containerData?.containerData?.sectionheadinglink_1651730460
            ?.ctaAriaLabel
        }
      />
      <SiteContainer className=" !pl-6 !pr-0 2md:!pl-12 lg:!px-12 overflow-hidden ">
        <Box as="div" className="mb-[0]">
          <Row>
            <Columns className="col-12 col-sm-12 col-lg-12 col-xl-12">
              <EmblaMassOfferSlider
                base={1.2}
                xsm={2.2}
                sm={2.2}
                md={3.4}
                lg={4}
                xl={4}
                xml={5}
                xxl={6}
              />
            </Columns>
          </Row>
        </Box>
      </SiteContainer>
    </>
  ) : null;
};

export const TrendingProductsWrapper = ({ aemData }: any) => {
  const { data: popularItems } = useTrendingItems(true);
  return popularItems?.products?.nbHits ? (
    <>
      <SectionTitle
        as="h2"
        title={
          aemData?.containerData?.containerData?.sectionheadinglink_1236224592
            ?.heading
        }
        ctaText={
          aemData?.containerData?.containerData?.sectionheadinglink_1236224592
            ?.ctatext
        }
        ctaLink={
          aemData?.containerData?.containerData?.sectionheadinglink_1236224592
            ?.ctalink
        }
        ctatarget={
          aemData?.containerData?.containerData?.sectionheadinglink_1236224592
            ?.ctatarget
        }
        ctalabel={
          aemData?.containerData?.containerData?.sectionheadinglink_1236224592
            ?.ctaAriaLabel
        }
      />
      <SiteContainer className=" !pl-6 !pr-0 2md:!pl-12 lg:!px-12 overflow-hidden ">
        <Box as="div" className="mb-[0]">
          <Row>
            <Columns className="col-12 col-sm-12 col-lg-12 col-xl-12">
              <EmblaTrendingProductSlider
                base={1.2}
                xsm={2.2}
                sm={2.2}
                md={3.4}
                lg={4}
                xl={4}
                xml={5}
                xxl={6}
              />
            </Columns>
          </Row>
        </Box>
      </SiteContainer>
    </>
  ) : null;
};

export const SpecificDeals = ({ aemData }: any) => {
  const { storeRegion, storeID } = useStoreDetails();
  const [homeProductData, setHomeProductData] = useState<any>({});
  useEffect(() => {
    if (storeRegion?.length && storeID?.length) {
      searchMultiIndex({
        homeContentData: aemData?.containerData,
        storeID,
        storeRegion,
      })
        .then((data) => {
          setHomeProductData(data);
        })
        .catch(() => { });
    }
  }, [storeRegion]);
  return homeProductData?.results?.[2]?.hits?.length === 0 ? null : (
    <>
      <SectionTitle
        as="h2"
        title={
          aemData?.containerData?.containerData?.sectionheadinglink_50289148
            ?.heading
        }
        ctaText={
          aemData?.containerData?.containerData?.sectionheadinglink_50289148
            ?.ctatext
        }
        ctaLink={
          aemData?.containerData?.containerData?.sectionheadinglink_50289148
            ?.ctalink
        }
        ctatarget={
          aemData?.containerData?.containerData?.sectionheadinglink_50289148
            ?.ctatarget
        }
        ctalabel={
          aemData?.containerData?.containerData?.sectionheadinglink_50289148
            ?.ctaAriaLabel
        }
      />
      <SiteContainer className=" !pl-6 !pr-0 2md:!pl-12 lg:!px-12 overflow-hidden ">
        <Box as="div" className="mb-[0]">
          <Row>
            <Columns className="col-12 col-sm-12 col-lg-12 col-xl-12">
              <EmblaSpecificDealsSlider
                base={1.2}
                xsm={2.2}
                sm={2.2}
                md={3.4}
                lg={4}
                xl={4}
                xml={5}
                xxl={6}
              />
            </Columns>
          </Row>
        </Box>
      </SiteContainer>
    </>
  );
};
